'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var name = 'Route';

exports.default = { name: name, render: render };


function render() {
  throw new Error('<Route /> should not be rendered');
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9yb3V0ZS5qcyJdLCJuYW1lcyI6WyJuYW1lIiwicmVuZGVyIiwiRXJyb3IiXSwibWFwcGluZ3MiOiI7Ozs7OztBQUNBLElBQU1BLE9BQU8sT0FBYjs7a0JBRWUsRUFBRUEsVUFBRixFQUFRQyxjQUFSLEU7OztBQUVmLFNBQVNBLE1BQVQsR0FBa0I7QUFDaEIsUUFBTSxJQUFJQyxLQUFKLENBQVUsa0NBQVYsQ0FBTjtBQUNEIiwiZmlsZSI6InJvdXRlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiXG5jb25zdCBuYW1lID0gJ1JvdXRlJ1xuXG5leHBvcnQgZGVmYXVsdCB7IG5hbWUsIHJlbmRlciB9XG5cbmZ1bmN0aW9uIHJlbmRlcigpIHtcbiAgdGhyb3cgbmV3IEVycm9yKCc8Um91dGUgLz4gc2hvdWxkIG5vdCBiZSByZW5kZXJlZCcpXG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ../~/@segment/deku-enroute/lib/route.js
// module id = 1041
// module chunks = 0